module.exports = __webpack_public_path__ + "static/media/paper-blue_icon.2621f155.svg";